/**
 * Generates a local initials-based avatar as a data URI (SVG).
 * No external network requests are made.
 *
 * @param {string} displayName - The user's display name
 * @returns {string} A data:image/svg+xml URI
 */

// Deterministic color from a string
function stringToColor(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const h = ((hash % 360) + 360) % 360;
  return `hsl(${h}, 55%, 45%)`;
}

export function getInitialsAvatarDataURI(displayName) {
  const name = (displayName || '').trim();
  const initials =
    name
      .split(' ')
      .map((p) => p.charAt(0))
      .join('')
      .substring(0, 2)
      .toUpperCase() || '?';

  const bg = stringToColor(name || '?');

  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="0 0 128 128">
  <rect width="128" height="128" fill="${bg}" rx="64"/>
  <text x="50%" y="50%" fill="#fff" font-family="Roboto,Helvetica,Arial,sans-serif" font-size="62" font-weight="400" letter-spacing="1" text-anchor="middle" dominant-baseline="central">${initials}</text>
</svg>`;

  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}
